import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";

const styles = {
  para: {
    fontSize: 16
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    width: "80%"
  }
};

const srm20 = props => {
  const { classes } = props;
  return (
    <div>
      <Typography variant="h5">3D scanning Technology</Typography>
      <Typography className={classes.para} paragraph>
        3D scanning is the process of analyzing a real-world object or
        environment to collect data on its shape and possibly its appearance
        (e.g. colour). The collected data can then be used to construct digital
        3D models. <br />
        Contact type scanners probe the subject through physical touch, while
        the object is in contact with or resting on a precision flat surface
        plate, ground and polished to a specific maximum of surface roughness.
        <br />
        Non-contact active type scanners emit some kind of radiation or light
        and detect its reflection or radiation passing through object in order
        to probe an object or environment. Possible types of emissions used
        include light, ultrasound or x-ray.
      </Typography>
      {/* <Typography variant="h6">Advantages</Typography>
      <Typography className={classes.para} paragraph>
        Para
      </Typography>
      <Typography variant="h6">Limitations</Typography> */}
      <Typography variant="h5">3D Scanning Assignment</Typography>
      <Typography variant="h6">
        Scanning device: 3D Systems Sense (1st Gen)
      </Typography>
      <Typography className={classes.para} paragraph>
        This is Hand-held laser scanners which create a 3D image through the
        triangulation mechanism. Triangulation based 3D laser scanners use laser
        light to probe the environment. The scanner creates a LASER dot on the
        object surface. The laser dot, the camera and the laser emitter form a
        triangle which is used to determine the distance of surface from
        scanner.
        <br />I downloaded{" "}
        <Link href={"https://www.3dsystems.com/shop/support/sense/downloads"}>
          Sense v2.2
        </Link>{" "}
        and activated the program using their online activation service. It took
        few minutes but the social sign in features were not working. <br />
        The scanner need to be connected all time to PC in order to use any
        features. Also, after scan is complete it is not possible to use any
        editing feature of software. <br /> The software saves the files by
        default in '.obj' format.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./dscan/sense-3d-scanner_01.jpg"
          alt="3dscan"
        />
      </div>
      <Typography className={classes.para} paragraph>
        I attached the scanner the to my laptop using a double side adhesive
        tape. To make sure I stay at a constant distance I used a white rope
        attached it base of object to be scanned. This worked for relatively
        small objects. I was able to scan the PC below very fast with out losing
        track of sensor. <br />
        For big objects I had to rely on the circle I made with chalk.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./dscan/scan_comp1.jpeg"
          alt="3dscan"
        />
      </div>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./dscan/scan_comp2.jpeg"
          alt="3dscan"
        />
      </div>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./dscan/scan_chair2.jpeg"
          alt="3dscan"
        />
      </div>

      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./dscan/scan_comp3.jpeg"
          alt="3dscan"
        />
      </div>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./dscan/scan_chair1.jpeg"
          alt="3dscan"
        />
      </div>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./dscan/blackchair.png"
          alt="3dscan"
        />
      </div>

      <div className={classes.imgdiv}>
        <img className={classes.img} src="./dscan/comp.png" alt="3dscan" />
      </div>

      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./dscan/whitechair.png"
          alt="3dscan"
        />
      </div>

      <Typography variant="h6">files</Typography>
      <Typography className={classes.para} paragraph>
        <Link href={"https://skfb.ly/6HLWQ"}>Brown Chair</Link> <br />
        <Link href={"https://skfb.ly/6HLZA"}> Whitish Chair</Link> <br />
      </Typography>
    </div>
  );
};

export default withStyles(styles)(srm20);
